import React from "react";

const TimeProgress = ({ lifeProgress }) => (
  <>
    <div className="w-full bg-black rounded-full border-2 border-white h-10 mt-28 mb-4 relative">
      <div
        className="bg-white h-10 rounded-full flex items-center px-4 transition-all duration-500 ease-in-out overflow-hidden"
        style={{ width: `${lifeProgress}%` }}
      >
        <p className="font-bold text-xl md:text-2xl text-black whitespace-nowrap">
          Time is Fading... Day by Day
        </p>
      </div>
    </div>

    {/* Display Percentages Below the Bar */}
    <div className="flex justify-between px-4 mb-32">
      <p className="font-bold text-sm md:text-lg text-white">
        Passed: {lifeProgress.toFixed(2)}%
      </p>
      <p className="font-bold text-sm md:text-lg text-white">
        Remaining: {(100 - lifeProgress).toFixed(2)}%
      </p>
    </div>
  </>
);

export default TimeProgress;
